<template>
    <div class="relative gm-dropdown-button" v-on-clickaway="away">
        <div role="button" class="inline-block select-none gm-dropdown-button__trigger" @click="open = !open">
            <slot name="link"></slot>
        </div>
        <div class="absolute pin-r w-full mt-2 z-50 gm-dropdown-button__menu" v-show="open" @click="open = !open">
            <slot name="dropdown"></slot>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
export default {
    mixins: [ clickaway ],
    name: 'DropdownButton',
    data() {
      return {
        open: false,
      };
    },
    methods: {
      away()
      {
          this.open = false;
      },
    },
};
</script>

<style scoped>
/* Row/bulk "Actions" trigger and menu (design system §3.17). The slot markup
   belongs to the legacy tables, so only the chrome is re-skinned here. */
.gm-dropdown-button__trigger >>> .border {
  min-height: 40px;
  padding: 0 10px 0 14px;
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  transition: background-color 120ms ease, border-color 120ms ease;
}

.gm-dropdown-button__trigger >>> .border:hover {
  background: var(--gs-muted);
  border-color: var(--gs-border-strong);
}

.gm-dropdown-button__trigger >>> .border svg {
  width: 14px;
  height: 14px;
  color: var(--gs-muted-foreground);
}

.gm-dropdown-button__menu {
  right: 0;
  left: auto;
  width: max-content;
  min-width: 100%;
}

.gm-dropdown-button__menu >>> .shadow {
  min-width: 160px;
  padding: 4px;
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  box-shadow: var(--gs-shadow-md);
  text-align: left;
}

.gm-dropdown-button__menu >>> .p-2 {
  padding: 9px 12px;
  border-radius: var(--gs-radius-sm);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 120ms ease;
}

.gm-dropdown-button__menu >>> .p-2:hover {
  background: var(--gs-muted);
}
</style>
